var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"dituContent-3",staticStyle:{"border":"#ccc solid 1px"},attrs:{"id":"dituContent"}})])}]

export { render, staticRenderFns }